"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationMetadataToJSON = exports.NotificationMetadataFromJSONTyped = exports.NotificationMetadataFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function NotificationMetadataFromJSON(json) {
    return NotificationMetadataFromJSONTyped(json, false);
}
exports.NotificationMetadataFromJSON = NotificationMetadataFromJSON;
function NotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'notificationType': (0, _1.NotificationTypeFromJSON)(json['notificationType']),
        'nftUri': !(0, runtime_1.exists)(json, 'nftUri') ? undefined : json['nftUri'],
        'mintDate': !(0, runtime_1.exists)(json, 'mintDate') ? undefined : json['mintDate'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'guildId': !(0, runtime_1.exists)(json, 'guildId') ? undefined : json['guildId'],
        'winningCriteria': !(0, runtime_1.exists)(json, 'winningCriteria') ? undefined : (0, _1.WinningCriteriaFromJSON)(json['winningCriteria']),
        'winnerMessage': !(0, runtime_1.exists)(json, 'winnerMessage') ? undefined : json['winnerMessage'],
        'challengeName': !(0, runtime_1.exists)(json, 'challengeName') ? undefined : json['challengeName'],
        'rewardName': !(0, runtime_1.exists)(json, 'rewardName') ? undefined : json['rewardName'],
        'assetId': !(0, runtime_1.exists)(json, 'assetId') ? undefined : json['assetId'],
        'challengeEndDate': !(0, runtime_1.exists)(json, 'challengeEndDate') ? undefined : json['challengeEndDate'],
        'amount': !(0, runtime_1.exists)(json, 'amount') ? undefined : json['amount'],
        'rewardType': !(0, runtime_1.exists)(json, 'rewardType') ? undefined : (0, _1.RewardTypeFromJSON)(json['rewardType']),
    };
}
exports.NotificationMetadataFromJSONTyped = NotificationMetadataFromJSONTyped;
function NotificationMetadataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'notificationType': (0, _1.NotificationTypeToJSON)(value.notificationType),
        'nftUri': value.nftUri,
        'mintDate': value.mintDate,
        'description': value.description,
        'guildId': value.guildId,
        'winningCriteria': (0, _1.WinningCriteriaToJSON)(value.winningCriteria),
        'winnerMessage': value.winnerMessage,
        'challengeName': value.challengeName,
        'rewardName': value.rewardName,
        'assetId': value.assetId,
        'challengeEndDate': value.challengeEndDate,
        'amount': value.amount,
        'rewardType': (0, _1.RewardTypeToJSON)(value.rewardType),
    };
}
exports.NotificationMetadataToJSON = NotificationMetadataToJSON;
